<template>
  <modal class="message-modal" title="处理订单" buttonsHidden>
    <vx-form class="w-full" layout="h" label-align="center">
      <form-item label="备注" >
        <vs-textarea class="w-full" placeholder="请输入订单备注" v-model="dealContent" />
      </form-item>
    </vx-form>
    <vs-button class="mr-2" @click="deal(23)">接受</vs-button>
    <vs-button class="mr-2" color="danger" @click="deal(24)">拒接</vs-button>
    <vs-button class="mr-2" color="grey" @click="$modalClose()">关闭</vs-button>
  </modal>
</template>
<script>
export default {
  props: {
    order: Object,
    onOk: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      dealContent: ''
    }
  },
  methods: {
    async deal(status) {
      const data = {
        orderid: this.order.orderid,
        status: status,
        content: this.dealContent,
      }
      await this.$s.order.deal(this.order.orderid, data)
      this.$notify({
        title: '订单处理成功',
        text: status == 23 ? '您已成功接受订单' : '订单已拒接，用户支付的款项将会自动退还到用户支付账户',
      })
      this.$modalClose()
      this.order.status = status
      this.onOk(this.order)
    }
  }

}
</script>